import React from 'react';

export default function BottomRightCorner() {
  return (
    <svg
      style={{ display: 'block' }}
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M22 23H23V22L23 0H22L22 22L0 22V23L22 23Z" fill="white" />
    </svg>
  );
}
